import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Form, Input, Select } from "antd";
import backArrow from "../../../../Assets/Images/back-arrow.svg";
import { Option } from "antd/es/mentions";
import { participantServices } from "../../../../Services/API/participantsServices";
import { TeamService } from "../../../../Services/API/TeamsService";
import Loader from "../../../../Components/Loader/Loader";
import { toast } from "react-toastify";
import { Gid } from "../../../../Utils/constants";

export default function TeamsForm() {
  const navigate = useNavigate();
  const location = useLocation();
  const action = location?.state?.action;
  const state = location?.state?.data;
  const [form] = Form.useForm();
  // const [participants, setParticipants] = useState([]);
  // const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [error, setError] = useState(null);

  // const fetchParticipants = () => {
  //   setLoading(true);
  //   participantServices
  //     .getAllParticipants()
  //     .then((response) => {
  //       setParticipants(response.data);
  //       setLoading(false);
  //     })
  //     .catch((error) => {
  //       toast.error(error?.response?.data || "Something went wrong");
  //       console.log(error);
  //       setLoading(false);
  //     });
  // };

  useEffect(() => {
    // fetchParticipants();
    if (state) {
      form.setFieldsValue({
        team_name: state?.team_title,
        // team_members: state?.members.map((member) => member?.id),
      });
    }
  }, [state]);

  const handleFinish = (values) => {
    // if (!values.team_members) {
    //   values.team_members = [];
    // }

    // Strip out the prefix from participant IDs
    // const participantIds = values.team_members.map((id) => {
    //   return id.replace(Gid?.metaobjectGid, "");
    // });

    // Strip out the prefix from participant IDs
    const participantIdWithGid = state?.members?.map((member) => member?.id);
    const participantIds = participantIdWithGid?.map((id) => {
      return id?.replace(Gid?.metaobjectGid, "");
    });

    const teamData = {
      team_name: values.team_name,
      // participant_ids: participantIds,
    };

    setSubmitLoading(true);
    const teamServicePromise =
      action === "add"
        ? TeamService.addTeam(teamData.team_name, [])
        : TeamService.updateTeam(
            state?.id,
            teamData.team_name,
            participantIds,
            state?.created_by
          );

    teamServicePromise
      .then((response) => {
        toast.success(
          action === "add"
            ? "Team added successfully"
            : "Team updated successfully"
        );
        navigate("/");
      })
      .catch((error) => {
        const errorMessage =
          error?.response?.data ||
          (action === "add" ? "Error adding team" : "Error updating team");

        toast.error(errorMessage);
        console.log(error);
      })
      .finally(() => {
        setSubmitLoading(false);
      });
  };

  // const tagRender = ({ label, value, closable, onClose }) => {
  //   return (
  //     <span className="tag-render" title={label}>
  //       {label}
  //       {closable ? " ," : ""}
  //     </span>
  //   );
  // };

  // return loading ? (
  //   <Loader />
  // ) : (
  return (
    <div className="form-page">
      <div className="forms-header-component">
        <div className="back-btn-container">
          <img
            src={backArrow}
            className="back-arrow"
            onClick={() => navigate("/")}
            alt="Back to teams"
          />
        </div>
        <div className="heading-container">
          {action === "add"
            ? "Add New Team"
            : `Edit Team - ${state?.team_title}`}
        </div>
      </div>
      <div className="fundraiser-form-component">
        <div className="form-container">
          <Form
            className="form-component"
            labelCol={{
              span: 8,
            }}
            colon={false}
            onFinish={handleFinish}
            form={form}
          >
            <Form.Item
              className="form-item"
              label={<div className="form-label">Team Name:</div>}
              name="team_name"
              rules={[
                {
                  required: true,
                  message: "Please Enter Team Name",
                },
              ]}
            >
              <Input placeholder="Team Name" />
            </Form.Item>
            {/* <Form.Item
              className="form-item"
              label={<div className="form-label">Team Members:</div>}
              name="team_members"
            >
              <Select
                mode="multiple"
                placeholder="Select team members"
                allowClear
                className="select"
                tagRender={tagRender}
                maxTagCount={3}
                maxTagPlaceholder={(omittedValues) =>
                  `+${omittedValues.length}`
                }
              >
                {participants?.map((member) => (
                  <Option key={member?.id} value={member?.id}>
                    {member?.participant_first_name} (
                    {member?.participant_email})
                  </Option>
                ))}
              </Select>
            </Form.Item> */}
          </Form>
          <div className="note">
            Note:
            <div>
              1. To Add or Remove a participant from the team, navigate to
              "Participant Tab".
            </div>
            <div>
              2. Participant can be added/edited via bulk upload or individual
              form submit , either way choose the relevant team name for the
              participant.
            </div>
          </div>
        </div>
      </div>
      <div className="forms-btns-container">
        <Button
          className="save-btn"
          onClick={() => form.submit()}
          loading={submitLoading}
        >
          Save
        </Button>
        <Button className="cancel-btn" onClick={() => navigate("/")}>
          Cancel
        </Button>
      </div>
    </div>
  );
}
